import React from "react";
import { Dialog, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import MuxPlayer from "@mux/mux-player-react";

interface MuxPlayerOverlayProps {
  open: boolean;
  onClose: () => void;
  mux_playback_id?: string | null;
  talktape_video_title?: string;
}

const MuxPlayerOverlay: React.FC<MuxPlayerOverlayProps> = ({
  open,
  onClose,
  mux_playback_id,
  talktape_video_title,
}) => {
  if (!mux_playback_id) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      disableEscapeKeyDown={false}
      PaperProps={{
        style: {
          backgroundColor: "#000",
          position: "relative",
          overflow: "visible",
          width: "auto",
          maxWidth: "90vw",
          maxHeight: "90vh",
        },
      }}
    >
      <IconButton
        onClick={onClose}
        sx={{
          position: "absolute",
          top: 6,
          right: 6,
          color: "white",
          width: 28,
          height: 28,
          zIndex: 10,
          backgroundColor: "rgba(0,0,0,0.3)",
          "&:hover": { backgroundColor: "rgba(0,0,0,0.5)" },
          "& svg": { fontSize: 18 },
        }}
      >
        <CloseIcon />
      </IconButton>

      <MuxPlayer
        playbackId={mux_playback_id}
        streamType="on-demand"
        metadata={{
          video_id: mux_playback_id,
          video_title: talktape_video_title || "Untitled",
        }}
        muted={false}
        style={{ width: "100%", display: "block", maxHeight: "90vh" }}
        {...{
          controls: true,
          autoplay: true,
        }}
      />
    </Dialog>
  );
};

export default MuxPlayerOverlay;
